import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { LoaderContainer, LoaderWrapper } from './styles'

export { LoaderContainer }

interface IProps {
  size?: 'small' | 'default' | 'large',
  extend?: boolean
}

const fontSizes = {
  small: 16,
  default: 24,
  large: 36
}

const Loader = (props: IProps) =>
  <LoaderWrapper extend={props.extend || false}>
    <Spin
      indicator={
        <LoadingOutlined
          style={{ fontSize: fontSizes[props.size || 'default'] }}
          spin
        />
      }
      size={props.size}
    />
  </LoaderWrapper>

export default Loader
